import * as React from "react"

import * as styles from "./Note.module.css"

const Note: React.FC = ({ children }) => {
  return <div className={styles.note}>{children}</div>
}

export default Note
